import useTitle from '../../utils/use-title';

const Page = ({ children, title }) => {
    useTitle(title, { dependencies: [title] });

    return children;
};

export default Page;
